import { Container } from "./styles";
import Accordion from "react-bootstrap/Accordion";
import externalLink from "../../assets/external-link.svg";

export function Courses() {
  return (
    <Container id="courses">
      <h2>Courses and Certificates</h2>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span>Advanced Software Development in Full-Stack JavaScript</span>
            <span className="course-tag">Course</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              This intensive 8-month program at the Abdul Aziz Al Ghurair School
              of Advanced Computing, powered by Code Fellows, offers a
              comprehensive learning experience with 900 hours of hands-on
              training. The course covers core technologies such as React,
              Node.js, and MongoDB, equipping students with the skills required
              to build robust, scalable, and dynamic web applications. Graduates
              of this program will gain expertise in front-end and back-end
              development, enabling them to confidently take on full-stack
              development projects in real-world settings.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`November 15, 2020`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://drive.google.com/file/d/1j73XLLqezmCP8TfKb8oRZDdNvBf94lL0/view?usp=drivesdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <span>OpenAPI Fundamentals (LFEL1011)</span>
            <span className="course-tag">Course</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Completed the OpenAPI Fundamentals (LFEL1011) course from The
              Linux Foundation, gaining a strong understanding of OpenAPI
              specifications, API design, and documentation. The course covered
              essential topics such as defining APIs, designing RESTful
              services, and using OpenAPI tools to streamline development
              processes. This certification demonstrates my ability to design
              and document APIs effectively, ensuring interoperability and
              scalability in modern software development.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`March 5, 2025`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://drive.google.com/file/d/1ySEF3MFLuWQEVag-AAnZzRm6hxthJS4d/view?usp=drivesdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <span>Introduction to Node.js (LFW111)</span>
            <span className="course-tag">Course</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Completed the Introduction to Node.js (LFW111) course from The
              Linux Foundation, gaining foundational knowledge of Node.js and
              its core concepts. The course covered topics such as asynchronous
              programming, modules, and building scalable web applications with
              Node.js. This certification demonstrates my ability to develop
              server-side applications and services using Node.js, enhancing my
              skills in backend development and JavaScript runtime environments.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`March 5, 2025`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://drive.google.com/file/d/1cy3FOkFr4NNtMEnsEzvJFnxsv5c1u3Zu/view?usp=drivesdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <span>API Academy Foundations</span>
            <span className="course-tag">Course</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Completed the API Academy Foundations course, covering key areas
              such as API Design, API Security, and API Product Management. The
              course provided in-depth knowledge of best practices for designing
              scalable and maintainable APIs, implementing robust security
              measures, and effectively managing the API lifecycle. This
              certification demonstrates my ability to build secure,
              high-quality APIs and manage them throughout their lifecycle,
              ensuring optimal performance and security in modern software
              development.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`March 11, 2025`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://drive.google.com/file/d/1daZb_hHcmtXmif4CIhdyVXv2Ry3NNjLX/view?usp=drivesdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <span>Amazon Teckathon Participating</span>
            <span className="certificate-tag">Certificate</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Participated in Amazon's Techathon, focusing on mobile development
              technologies, to create innovative mobile solutions and enhance
              user experience through technical problem-solving.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`Septemper 1, 2020`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://drive.google.com/file/d/1TqbdzAv8t1fJjrReLHymJ0OKRDVICf0M/view?usp=drivesdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <span>Frontend Developer (React) Certificate</span>
            <span className="certificate-tag">Certificate</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Successfully completed the Frontend Developer (React)
              certification exam on HackerRank, demonstrating expertise in
              React.js, JavaScript, and CSS. The exam covered core React
              concepts such as components, hooks, state management, and routing,
              along with JavaScript fundamentals and CSS styling techniques.
              This certification highlights my ability to build responsive,
              interactive web applications with a focus on clean, efficient code
              and seamless user experience.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`March 10, 2025`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://www.hackerrank.com/certificates/iframe/6991a70cdba3"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
          <Accordion.Header>
            <span>Software Engineer Certificate</span>
            <span className="certificate-tag">Certificate</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Successfully completed the Software Engineer certification exam on
              HackerRank, demonstrating proficiency in software development
              concepts, data structures, algorithms, and problem-solving skills.
              The exam tested my ability to write efficient, scalable code and
              apply best practices in areas such as object-oriented programming,
              time and space complexity, and debugging, validating my readiness
              for software engineering roles.{" "}
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`March 10, 2025`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://www.hackerrank.com/certificates/iframe/2cd0acca47a9"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="7">
          <Accordion.Header>
            <span>Certificate in JavaScript</span>
            <span className="certificate-tag">Certificate</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Successfully completed the JavaScript certification exam on
              HackerRank, validating my knowledge of key JavaScript concepts.
              This certification demonstrates my ability to apply JavaScript to
              solve practical coding challenges effectively.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`August 12, 2020`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://www.hackerrank.com/certificates/iframe/57a8b8e992b8"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="8">
          <Accordion.Header>
            <span>Certificate in Java</span>
            <span className="certificate-tag">Certificate</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Successfully completed the Java certification exam on HackerRank,
              showcasing my proficiency in core Java concepts such as
              object-oriented programming, data structures, algorithms, and
              exception handling. This certification validates my ability to
              write efficient, clean code and solve complex problems using Java.
            </div>
            <div className="courseFooter">
              <div className="date-of-issue">
                <p>Date of issue:</p>
                <p className="date">{`August 12, 2020`}</p>
              </div>
              <div className="project-links">
                <a
                  href="https://www.hackerrank.com/certificates/iframe/c00b20f29513"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
}
